<template>
  <div class="app-main">
    <div class="basic-info">
      <div class="basic-title-text">基本信息</div>
      <el-form :inline="true" :model="udetails" label-width="100px" style="font-size: 16px;">
        <el-form-item label="客户姓名：" style="width: 30%; margin-bottom: 5px;">
          <span>{{ udetails.uname }}</span>
        </el-form-item>
        <el-form-item label="身份证号：" style="width: 60%; margin-bottom: 5px;">
          <span>{{ udetails.ucardid }}</span>
        </el-form-item>
        <el-form-item label="客户电话：" style="width: 30%; margin-bottom: 5px;">
          <span>{{ udetails.uphone }}</span>
        </el-form-item>
        <el-form-item label="银行卡号：" style="width: 60%; margin-bottom: 5px;">
          <span>{{ udetails.ubankcard }}</span>
        </el-form-item>
        <el-form-item label="来源平台：" style="width: 30%; margin-bottom: 5px;">
          <span>{{ udetails.uplatform }}</span>
        </el-form-item>
        <el-form-item label="收入总额：" style="width: 60%; margin-bottom: 5px;">
          <span>{{ udetails.moneys }}</span>
        </el-form-item>
        <el-form-item label="开户地：" style="width: 30%; margin-bottom: 10px;">
          <span>{{ udetails.ubankaddress }}</span>
        </el-form-item>
        <el-form-item label="纳税总额：" style="width: 60%; margin-bottom: 10px;">
          <span>{{ udetails.taxs }}</span>
        </el-form-item>
        <el-form-item label="签约状态：" style="width: 30%; margin-bottom: 10px;">
          <span>{{ udetails.ustatus }}</span>
        </el-form-item>
        <el-form-item label="服务商：" style="width: 60%; margin-bottom: 10px;">
          <span>{{ udetails.uplatform }}</span>
        </el-form-item>
        <el-form-item label="签约日期：" style="width: 60%; margin-bottom: 10px;">
          <span>{{ udetails.utime }}</span>
        </el-form-item>
      </el-form>
      <div class="basic-img">
        <div class="basic-img-container">
          <div class="basic-img-container-text">身份证正面</div>
          <el-image style="width: 100px; height: 100px" :src="udetails.idcardforeurl" :preview-src-list="udetails.imgUrls">
            <div slot="error" class="image-slot"> <i class="el-icon-picture-outline"></i></div>
          </el-image>
        </div>
        <div class="basic-img-container">
          <div class="basic-img-container-text">身份证反面</div>
          <el-image class="basic-img-container-img" :src="udetails.idcardbackurl" fit="fill" :preview-src-list="udetails.imgUrls">
            <div slot="error" class="image-slot"> <i class="el-icon-picture-outline"></i></div>
          </el-image>
        </div>
        <div class="basic-img-container">
          <div class="basic-img-container-text">签名照片</div>
          <el-image class="basic-img-container-img" :src="udetails.signurl" fit="fill" :preview-src-list="udetails.imgUrls">
            <div slot="error" class="image-slot"> <i class="el-icon-picture-outline"></i></div>
          </el-image>
        </div>
      </div>
    </div>
    <div class="content-table">
      <el-table :data="udata" size='medium' height="500">
        <el-table-column prop="uid" label="ID号" align="center"></el-table-column>
        <el-table-column prop="ucardid" label="身份证号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="umonth" label="期数"></el-table-column>
        <el-table-column prop="utime" label="发放日期"></el-table-column>
        <el-table-column prop="umoney" label="收入金额"></el-table-column>
        <el-table-column prop="upayment" label="完税记录"></el-table-column>
        <el-table-column prop="uinvoice" label="发票号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="utax" label="纳税金额"></el-table-column>
      </el-table>
    </div>
    <!-- <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination
        @current-change="handleChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div> -->
    <div style="width: 100%; height: 10px;"></div>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'userdetail',
  data() {
    return {
      usidcard: '',
      udetails: {},
      udata: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  mounted() {
    console.log('user detail mounted');
    this.$store.commit('setPagestatus', 2);
    this.usidcard = this.$route.query.usidcard;
    this.fetchUserDetail();
  },
  methods: {
    fetchUserDetail() {
      api.fetchUserDetail({
        params: {
          params: {
            cardid: this.usidcard,
          },
        },
      }).then((res) => {
        this.udata = res.data;
        this.udetails = res.udetail;
        this.udetails.imgUrls = [this.udetails.idcardforeurl, this.udetails.idcardbackurl, this.udetails.signurl];
        this.total = res.count;
        if (!this.udata) {
          return;
        }
        let moneys = 0;
        let taxs = 0;
        this.udata.forEach((data) => {
          // data.uid = this.udetails.uid;
          data.ucardid = this.udetails.ucardid;
          moneys += (data.umoney ? Number(data.umoney) : 0);
          taxs += (data.utax ? Number(data.utax) : 0);
        });
        this.udetails.moneys = moneys.toFixed(2);
        this.udetails.taxs = taxs.toFixed(2);
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchPayDetail();
    },
  },
};
</script>

<style lang="less" scoped>

@media screen and (max-width: 1200px) {
  .app-main {
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .app-main {
    width: 100%;
  }
}

.app-main {
  .basic-info {
    background-color: #e0e0e0;
    margin: 10px 10px;
    border: 1px solid #fff;
    font-size: 15px;
    .basic-title-text {
      padding: 5px 0 10px 20px;
      font-size: 18px;
    }
    .basic-img {
      margin: 5px 0 10px 30px;
      .basic-img-container {
        display: inline-block;
        margin-right: 40px;
        .basic-img-container-text {
          margin-bottom: 10px;
          text-align: center;
        }
        .basic-img-container-img {
          width: 100px;
          height: 100px;
        }
      }
    }
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  margin: 20px 30px 0px 30px;
  padding-bottom: 10px;
  font-size: 15px;
}
.content-pagination {
  padding: 20px 40px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/userdetail.vue